import { MessageType } from '@protos/chat/message_type_pb'

export enum CustomMessageTypes {
  DOCUMENT = 'DOCUMENT',
  AUDIO = 'AUDIO',
}

export type MessageTypes = CustomMessageTypes | MessageType
